import { Component, computed, inject, OnInit } from '@angular/core';
import { MspSemantixLogoComponent } from 'src/app/page_component_item/msp-semantix-logo/msp-semantix-logo.component';
import { GlobalService } from 'src/app/services/global/global.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';

@Component({
	standalone: true,
	imports: [MspSemantixLogoComponent],
	selector: 'app-welcome-page',
	templateUrl: './welcome-page.component.html',
	styleUrls: ['./welcome-page.component.scss'],
})
export class WelcomePageComponent implements OnInit {
	protected ProfileService = inject(ProfileService);
	protected GlobalService = inject(GlobalService);

	labels: LabelsInterface;
	darkMode = false;

	constructor(private LabelsService: LabelsService) {
		this.labels = computed(() => this.LabelsService.labels())();
	}

	isLoadingLabels = true;

	ngOnInit(): void {
		this.GlobalService.darkModeOn.subscribe({
			next: (darkModeBool) => {
				this.darkMode = darkModeBool;
			},
		});
	}
}
